module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.acff0dcd.jpeg";